import React, { useEffect } from "react";

export default function Toast({ message, type = "success", onClose, duration = 4000 }) {
  useEffect(() => {
    if (message) {
      const timer = setTimeout(() => {
        onClose();
      }, duration);
      return () => clearTimeout(timer);
    }
  }, [message, duration, onClose]);

  if (!message) return null;

  const isSuccess = type === "success";

  return (
    <div
      className="w3-animate-opacity w3-card-4"
      style={{
        position: "fixed",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        backgroundColor: isSuccess ? "#d4edda" : "#f8d7da",
        color: isSuccess ? "#155724" : "#721c24",
        border: `1px solid ${isSuccess ? "#c3e6cb" : "#f5c6cb"}`,
        padding: "14px 24px",
        borderRadius: "8px",
        boxShadow: "0 4px 12px rgba(0,0,0,0.3)",
        zIndex: 9999,
        fontWeight: "bold",
        minWidth: "280px",
        textAlign: "center",
      }}
    >
      {message}
      <span
        style={{
          marginLeft: 12,
          cursor: "pointer",
          fontWeight: "normal",
          float: "right",
        }}
        onClick={onClose}
      >
        ✖
      </span>
    </div>
  );
}
